<template>
  <div>
    <div class="text-center" v-if="loading">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div v-if="!loading">
      <b-form>
        <!-- Campo Nome Completo -->
        <div class="row">
          <div class="col-md-12">
            <b-form-group
              class="mb-3"
              label="Nome Completo"
              invalid-feedback="Digite seu nome completo e sem abreviações"
            >
              <b-form-input
                :disabled="eSocial == 'Qualificado'"
                @input="verificarNome(campo.nomeCompleto)"
                v-model="campo.nomeCompleto"
                type="text"
                :state="validacaoNome"
                autocomplete="off"
                maxlength="60"
                trim
              ></b-form-input>
              <div class="text-center">
                <p
                  v-if="campo.nomeCompleto"
                  class="badge position-absolute"
                  :class="{
                    'bg-success': campo.nomeCompleto.length !== 60,
                    'bg-danger': campo.nomeCompleto.length === 60,
                  }"
                >
                  {{ campo.nomeCompleto.length }} / 60
                </p>
              </div>
            </b-form-group>
          </div>
        </div>

        <!-- Linha com Data de Nascimento, CPF e PIS/INSS -->
        <div class="row">
          <!-- Data de nascimento -->
          <div class="col-md-4">
            <b-form-group class="mb-3" label="Data de nascimento">
              <date-picker
                v-model="campo.DT_NASC"
                value-type="YYYY-MM-DD"
                format="DD/MM/YYYY"
                :disabled="eSocial == 'Qualificado'"
                :disabled-date="disabledData()"
                append-to-body
                :editable="false"
                default-panel="year"
                :default-value="dateDefault"
              />
            </b-form-group>
          </div>
          <!-- CPF -->
          <div class="col-md-4">
            <b-form-group class="mb-3" label="CPF">
              <b-form-input
                disabled
                v-mask="'###.###.###-##'"
                v-model="campo.cpf"
                type="text"
              ></b-form-input>
            </b-form-group>
          </div>
          <!-- PIS/INSS com ícone acionador -->
          <div class="col-md-4">
            <div class="form-group">
              <b-form-group class="mb-3" :state="pisValidado">
                <template #label>
                  <div class="d-flex align-items-center">
                    <span>N° PIS/INSS</span>
                    <i
                      class="fas fa-question-circle interrogacao ml-2"
                      id="tooltip-pis"
                      @click="abrirModalPis"
                      style="cursor: pointer; margin-left: 5px;"
                    ></i>
                  </div>
                </template>
                <b-form-input
                  :state="pisValidado"
                  v-model="campo.NR_PIS"
                  v-mask="'###.#####.##-#'"
                  @input="validarPiss(campo.NR_PIS)"
                  :disabled="eSocial == 'Qualificado'"
                  type="text"
                ></b-form-input>
              </b-form-group>
            </div>
          </div>

        </div>

        <!-- Estado Civil, Sexo, Orientação Sexual e Características Físicas -->
        <div class="row">
          <div class="col-md-3">
            <b-form-group class="mb-3" label="Estado Civil">
              <multiselect
                v-model="campo.selectEstadoCivil"
                placeholder="Selecione"
                :show-labels="false"
                :allow-empty="false"
                label="name"
                :options="optionEstadoCivil"
              >
                <span slot="noResult">Nenhum resultado encontrado.</span>
              </multiselect>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group class="mb-3" label="Sexo">
              <multiselect
                v-model="campo.selectSexo"
                placeholder="Selecione"
                :show-labels="false"
                :allow-empty="false"
                label="name"
                :options="optionSexo"
              >
                <span slot="noResult">Nenhum resultado encontrado.</span>
              </multiselect>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group class="mb-3" label="Orientação Sexual">
              <multiselect
                v-model="campo.selectOrientacaoSexual"
                placeholder="Selecione"
                :show-labels="false"
                :allow-empty="false"
                label="name"
                :options="optionOrientacao"
              >
                <span slot="noResult">Nenhum resultado encontrado.</span>
              </multiselect>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group class="mb-3" label="Características Físicas">
              <multiselect
                v-model="campo.selectCaracteristasFisicas"
                placeholder="Selecione"
                :show-labels="false"
                :allow-empty="false"
                label="nm_raca_cor"
                :options="optionCaracFisica"
              >
                <span slot="noResult">Nenhum resultado encontrado.</span>
              </multiselect>
            </b-form-group>
          </div>
        </div>
      </b-form>

      <!-- Botões Salvar e Próximo -->
      <div class="row">
        <div class="mt-1 d-flex justify-content-end">
          <b-button
            variant="success"
            class="d-flex"
            @click="salvarDadosPessoais(true)"
            :disabled="loadingSalvar"
            data-tooltip="Salvar"
            data-tooltip-location="left"
          >
            <i class="mdi mdi-content-save"></i>
            <b-spinner
              class="ms-2"
              small
              variant="primary"
              v-if="loadingSalvar"
            ></b-spinner>
          </b-button>
        </div>
      </div>
      <div class="row">
        <div class="mt-3 d-flex justify-content-end">
          <b-button
            variant="primary"
            @click="navegar()"
            data-tooltip="Próximo"
            data-tooltip-location="bottom"
          >
            <i class="mdi mdi-arrow-right-circle font-size-15"></i>
          </b-button>
        </div>
      </div>
    </div>

    <!-- Modal para informações do PIS/INSS -->
    <b-modal
      v-model="showModalPis"
      size="lg"
      title="Informações sobre PIS/INSS"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <div class="d-flex justify-content-center">
        <div class="col-md-12 card">
          <div class="card-body">
            <div class="row">
              <h5 class="mt-3 mb-3 font-bold">
                Para gerar o número do PIS/NIS/NIT,
                solicite o cadastramento diretamente em uma agência da Caixa Econômica Federal,
                pelo sistema do empregador via Conectividade Social  ou pelo número 135.
              </h5>
            </div>
            <div class="row">
              <div class="mt-5 d-flex justify-content-end">
                <b-button
                  variant="success"
                  class="mt-1 me-1"
                  @click="fecharModalPis"
                  data-tooltip="Fechar"
                  data-tooltip-location="bottom"
                >
                  Fechar
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import Swal from "sweetalert2";

export default {
  props: ["dadosPessoaisLoockUp"],
  components: {
    Multiselect,
  },
  data() {
    return {
      dados: {},
      loading: true,
      loadingSalvar: false,
      showModalPis: false,
      campo: {
        nomeCompleto: "",
        nomeVerifica: "",
        DT_NASC: "",
        cpf: "",
        possuiDeficiencia: "",
        NR_PIS: "",
        selectPossuiDeficiencia: {},
        selectCnh: {},
        selectRegistroProfissional: {},
        selectEstadoCivil: {},
        selectSexo: {},
        selectOrientacaoSexual: "",
        selectCaracteristasFisicas: {},
        registroProfissional: {},
      },
      dateDefault: new Date().getFullYear() - 17 + "-01-01",
      campoBK: [],
      verificaCpf: null,
      optionRegistroProfissional: [
        { tp_registro: null, name: "Não possui" },
        { tp_registro: "P", name: "Protocolo" },
        { tp_registro: "R", name: "Registro" },
        { tp_registro: "V", name: "Visto" },
      ],
      optionRegistro: [],
      optionDeficiencia: [
        { value: true, name: "Sim" },
        { value: false, name: "Não" },
      ],
      optionEstadoCivil: [
        { TP_EST_CIVIL: "C", name: "Casado(a)" },
        { TP_EST_CIVIL: "D", name: "Divorciado(a)" },
        { TP_EST_CIVIL: "R", name: "Relação Estável" },
        { TP_EST_CIVIL: "S", name: "Separado(a)" },
        { TP_EST_CIVIL: "T", name: "Solteiro(a)" },
        { TP_EST_CIVIL: "V", name: "Viúvo(a)" },
      ],
      deficienciaDisabled: true,
      optionTipoDeficiencia: [],
      optionCaracFisica: [],
      optionTipoCnh: [
        { TP_CNH: "D", name: "Definitivo" },
        { TP_CNH: "N", name: "Não tem" },
        { TP_CNH: "P", name: "Provisório" },
      ],
      optionSexo: [
        { TP_SEXO: "F", name: "Feminino" },
        { TP_SEXO: "M", name: "Masculino" },
      ],
      optionOrientacao: [
        { tp_orientacao: "E", name: "Heterossexual" },
        { tp_orientacao: "O", name: "Homossexual" },
        { tp_orientacao: "B", name: "Bissexual" },
        { tp_orientacao: "P", name: "Pansexual" },
        { tp_orientacao: "A", name: "Assexual" },
        { tp_orientacao: "U", name: "Outro" },
        { tp_orientacao: "R", name: "Prefiro não informar" },
      ],
      pisValidado: null,
      eSocial: "",
      validacaoNome: null,
      proximo: null,
      customNoResultText: "Nenhum resultado encontrado",
      customNoOptionsText: "Nenhuma opção disponível",
      deficiencias: [],
      cdTipoPessoa: "",
      disableProfissional: false
    };
  },
  async created() {
    await this.fetchUserProfile();
    await this.prepararDadosPessoais();
  },
  methods: {
    async navegar() {
      if (this.validarDadosPessoais() && !this.verificarInputs()) {
        const result = await Swal.fire({
          title: "ATENÇÃO",
          text: "Deseja avançar sem salvar os dados?",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Avançar",
          confirmButtonText: "Salvar",
        });
        if (result.isConfirmed) {
          await this.salvarDadosPessoais();
          await this.deletarPCDs(true);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.close();
        }
        this.$emit("navegar", "redesSociais", true);
      } else if (this.validarDadosPessoais() && this.verificarInputs()) {
        this.$emit("navegar", "PCD", true);
      }
    },
    verificarInputs() {
      if (this.campoBK.nomeCompleto != this.campo.nomeCompleto) return false;
      if (this.campoBK.DT_NASC != this.campo.DT_NASC) return false;
      if (
        this.campoBK.NR_PIS.replace(/\W/g, "") !=
        this.campo.NR_PIS.replace(/\W/g, "")
      )
        return false;
      if (this.campoBK.selectCnh != this.campo.selectCnh) return false;
      if (
        this.campoBK.selectRegistroProfissional !=
        this.campo.selectRegistroProfissional
      )
        return false;
      if (this.campoBK.selectEstadoCivil != this.campo.selectEstadoCivil)
        return false;
      if (this.campoBK.selectSexo != this.campo.selectSexo) return false;
      if (
        this.campoBK.selectOrientacaoSexual != this.campo.selectOrientacaoSexual
      )
        return false;
      if (
        this.campoBK.selectCaracteristasFisicas !=
        this.campo.selectCaracteristasFisicas
      )
        return false;
      if (
        this.campoBK.possuiDeficiencia.value !=
        this.campo.possuiDeficiencia.value
      )
        return false;
      return true;
    },
    deletarPCDs() {
      if (
        this.campo.possuiDeficiencia.value == false &&
        this.deficiencias.length > 0
      ) {
        const promises = this.deficiencias.map(d => this.$http.delete(`api/profileErp/deficiencias/${d.Id || d.id}`));
        Promise.all(promises)
          .then(() => {
            this.$tools.alerta("Deficiências excluídas com sucesso", "success");
            this.deficiencias = [];
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    async carregarAbaPCD() {
      if (this.campo.possuiDeficiencia.value == false) {
        this.$emit("ativarPCD", false);
      } else {
        this.$emit("ativarPCD", true);
      }
    },
    async prepararDadosPessoais() {
      try {
        const isErp = this.$store.state.user?.tipoUsuario === 'erp' || this.$store.state.me?.user_erp;
        const endpointMe = isErp ? "api/authErp/meErp" : "api/auth/me";
        
        const respMe = await this.$http.get(endpointMe);
        const enviaParaIndex = { authMe: respMe.data };
        this.cdTipoPessoa = respMe.data.tp_Pessoa.cd_tp_pessoa;
        
        // Pre-warm the backend token validation cache to prevent race conditions on concurrent ERP API calls
        const respRacaCor = await this.$http.get("api/profileErp/raca-cor");

        const [
          respDadosPessoais,
          respProfissional,
          respDeficiencia,
          respEstadoCivil,
          respOrientacaoSexual,
          respCnh
        ] = await Promise.all([
          this.$http.get("api/profileErp/dados-pessoais"),
          this.$http.get("api/profileErp/formacoes"),
          this.$http.get("api/profileErp/deficiencias"),
          this.$http.get("api/profileErp/estado-civil"),
          this.$http.get("api/profileErp/orientacao-sexual"),
          this.$http.get("api/profileErp/cnh-categorias"),
        ]);
        
        this.optionCaracFisica = (respRacaCor.data || []).map((item) => {
          const descricao = item.Descricao || item.descricao || item.nm_raca_cor || item.name || "";
          return {
            ...item,
            Id: item.Id || item.id || item.sq_raca_cor,
            id: item.Id || item.id || item.sq_raca_cor,
            sq_raca_cor: item.Id || item.id || item.sq_raca_cor,
            nm_raca_cor: descricao,
            Descricao: descricao,
            name: descricao,
          };
        });
        
        this.optionEstadoCivil = (respEstadoCivil.data || []).map((item) => {
          const descricao = item.Descricao || item.descricao || item.name || "";
          return {
            ...item,
            Id: item.Id || item.id,
            id: item.Id || item.id,
            TP_EST_CIVIL: item.Sigla || item.sigla || item.TP_EST_CIVIL,
            Descricao: descricao,
            name: descricao,
          };
        });
        
        this.optionOrientacao = (respOrientacaoSexual.data || []).map((item) => {
          const descricao = item.Descricao || item.descricao || item.name || "";
          return {
            ...item,
            Id: item.Id || item.id,
            id: item.Id || item.id,
            tp_orientacao: item.Sigla || item.sigla || item.tp_orientacao,
            Descricao: descricao,
            name: descricao,
          };
        });
        
        this.optionTipoCnh = (respCnh.data || []).map((item) => {
          const descricao = item.Descricao || item.descricao || item.TipoCnh || item.name || "";
          return {
            ...item,
            Id: item.Id || item.id,
            id: item.Id || item.id,
            TP_CNH: item.Sigla || item.sigla || item.TipoCnh || item.TP_CNH,
            Descricao: descricao,
            name: descricao,
          };
        });
        
        // Normalize response object keys to support different casing styles and structured schemas
        const rawDados = respDadosPessoais.data || {};
        
        let nrPis = "";
        if (rawDados.Pis && typeof rawDados.Pis === 'object') {
          nrPis = rawDados.Pis.Numero || rawDados.Pis.numero || "";
        } else if (rawDados.pis && typeof rawDados.pis === 'object') {
          nrPis = rawDados.pis.numero || rawDados.pis.Numero || "";
        }
        if (!nrPis) {
          nrPis = rawDados.NR_PIS || rawDados.nrPis || rawDados.NrPis || rawDados.pis || rawDados.Pis || "";
        }

        let idEstadoCivil = rawDados.IdEstadoCivil || (rawDados.EstadoCivil && rawDados.EstadoCivil.Id) || null;
        let idRacaCor = rawDados.IdRacaCor || (rawDados.RacaCor && rawDados.RacaCor.Id) || null;
        let idOrientacao = rawDados.IdOrientacaoSexual || (rawDados.OrientacaoSexual && rawDados.OrientacaoSexual.Id) || null;
        let idSexo = rawDados.IdSexo || (rawDados.Sexo && rawDados.Sexo.Id) || null;
        let idTipoCnh = rawDados.IdTipoCnh || (rawDados.Cnh && rawDados.Cnh.Id) || null;

        // Fallbacks for older data structures if IDs are missing
        let tpCnh = "";
        if (!idTipoCnh) {
          if (rawDados.Cnh && typeof rawDados.Cnh === 'object') {
            const type = rawDados.Cnh.TipoCnh || rawDados.Cnh.tipoCnh || "";
            if (type.toLowerCase().startsWith("def") || type === "D") tpCnh = "D";
            else if (type.toLowerCase().startsWith("prov") || type === "P") tpCnh = "P";
            else tpCnh = "N";
          } else if (rawDados.cnh && typeof rawDados.cnh === 'object') {
            const type = rawDados.cnh.tipoCnh || rawDados.cnh.TipoCnh || "";
            if (type.toLowerCase().startsWith("def") || type === "D") tpCnh = "D";
            else if (type.toLowerCase().startsWith("prov") || type === "P") tpCnh = "P";
            else tpCnh = "N";
          } else {
            const type = rawDados.TP_CNH || rawDados.tpCnh || rawDados.TpCnh || rawDados.cnh || rawDados.Cnh || "N";
            if (typeof type === 'string') {
              if (type.toLowerCase().startsWith("def") || type === "D") tpCnh = "D";
              else if (type.toLowerCase().startsWith("prov") || type === "P") tpCnh = "P";
              else tpCnh = "N";
            } else {
              tpCnh = "N";
            }
          }
        }

        let tpSexo = "";
        if (!idSexo) {
          const rawSexoObj = rawDados.Sexo || rawDados.sexo || rawDados.TP_SEXO || "";
          let rawSexo = "";
          if (rawSexoObj && typeof rawSexoObj === 'object') {
            rawSexo = rawSexoObj.Descricao || rawSexoObj.descricao || rawSexoObj.Sigla || rawSexoObj.sigla || "";
          } else {
            rawSexo = rawSexoObj;
          }
          if (typeof rawSexo === 'string') {
            if (rawSexo.toLowerCase().startsWith("fem") || rawSexo === "F") tpSexo = "F";
            else if (rawSexo.toLowerCase().startsWith("masc") || rawSexo === "M") tpSexo = "M";
          }
        }

        let tpOrientacao = "";
        if (!idOrientacao) {
          const rawOrientacaoObj = rawDados.OrientacaoSexual || rawDados.orientacaoSexual || rawDados.TP_ORIENTACAO_SEXO || "";
          if (rawOrientacaoObj && typeof rawOrientacaoObj === 'object') {
            tpOrientacao = rawOrientacaoObj.Descricao || rawOrientacaoObj.descricao || "";
          } else {
            tpOrientacao = rawOrientacaoObj;
          }
          if (typeof tpOrientacao === 'string') {
            if (tpOrientacao.toLowerCase().startsWith("hetero") || tpOrientacao === "E") tpOrientacao = "E";
            else if (tpOrientacao.toLowerCase().startsWith("homo") || tpOrientacao === "O") tpOrientacao = "O";
            else if (tpOrientacao.toLowerCase().startsWith("bi") || tpOrientacao === "B") tpOrientacao = "B";
            else if (tpOrientacao.toLowerCase().startsWith("pan") || tpOrientacao === "P") tpOrientacao = "P";
            else if (tpOrientacao.toLowerCase().startsWith("ass") || tpOrientacao === "A") tpOrientacao = "A";
            else if (tpOrientacao.toLowerCase().startsWith("out") || tpOrientacao === "U") tpOrientacao = "U";
            else if (tpOrientacao.toLowerCase().startsWith("pref") || tpOrientacao === "R") tpOrientacao = "R";
          }
        }

        let sqRacaCor = "";
        if (!idRacaCor) {
          const rawRacaCorObj = rawDados.RacaCor || rawDados.racaCor || rawDados.SQ_RACA_COR || "";
          if (rawRacaCorObj && typeof rawRacaCorObj === 'object') {
            sqRacaCor = rawRacaCorObj.Descricao || rawRacaCorObj.descricao || rawRacaCorObj.Id || rawRacaCorObj.id || "";
          } else {
            sqRacaCor = rawRacaCorObj;
          }
        }

        let tpEstadoCivil = "";
        if (!idEstadoCivil) {
          const rawEstadoCivilObj = rawDados.EstadoCivil || rawDados.estadoCivil || rawDados.TP_EST_CIVIL || "";
          if (rawEstadoCivilObj && typeof rawEstadoCivilObj === 'object') {
            tpEstadoCivil = rawEstadoCivilObj.Descricao || rawEstadoCivilObj.descricao || rawEstadoCivilObj.Sigla || rawEstadoCivilObj.sigla || "";
          } else {
            tpEstadoCivil = rawEstadoCivilObj;
          }
          if (typeof tpEstadoCivil === 'string') {
            if (tpEstadoCivil.toLowerCase().startsWith("casad") || tpEstadoCivil === "C") tpEstadoCivil = "C";
            else if (tpEstadoCivil.toLowerCase().startsWith("divorc") || tpEstadoCivil === "D") tpEstadoCivil = "D";
            else if (tpEstadoCivil.toLowerCase().includes("estavel") || tpEstadoCivil === "R") tpEstadoCivil = "R";
            else if (tpEstadoCivil.toLowerCase().startsWith("separ") || tpEstadoCivil === "S") tpEstadoCivil = "S";
            else if (tpEstadoCivil.toLowerCase().startsWith("solte") || tpEstadoCivil === "T") tpEstadoCivil = "T";
            else if (tpEstadoCivil.toLowerCase().startsWith("viuv") || tpEstadoCivil === "V") tpEstadoCivil = "V";
          }
        }

        this.dados = {
          NR_PIS: nrPis,
          DT_NASC: rawDados.DataNascimento || rawDados.dataNascimento || rawDados.DT_NASC || rawDados.dtNasc || rawDados.DtNasc || "",
          IdTipoCnh: idTipoCnh,
          TP_CNH: tpCnh,
          IdSexo: idSexo,
          TP_SEXO: tpSexo,
          IdOrientacaoSexual: idOrientacao,
          TP_ORIENTACAO_SEXO: tpOrientacao,
          IdRacaCor: idRacaCor,
          SQ_RACA_COR: sqRacaCor,
          IdEstadoCivil: idEstadoCivil,
          TP_EST_CIVIL: tpEstadoCivil
        };
        
        enviaParaIndex.registroProfissional = respProfissional.data ? respProfissional.data[0] : null;
        enviaParaIndex.dadosPessoais = this.dados;
        this.deficiencias = respDeficiencia.data || [];
        
        if (this.deficiencias.length > 0) {
          this.campo.possuiDeficiencia = { value: true, name: "Sim" };
          this.carregarAbaPCD();
        } else {
          this.campo.possuiDeficiencia = { value: false, name: "Não" };
        }
        
        this.$emit("recebeDadosPessoais", enviaParaIndex);
        this.preencheCamposDaTela(respMe.data, respProfissional.data);
      } catch (err) {
        this.$tools.alerta(err.message || err, "error");
      }
    },
    preencheCamposDaTela(responseMe, responseProfissional) {
      this.campo.NR_PIS = this.dados.NR_PIS
        ? this.dados.NR_PIS.toString().padStart(11, "0")
        : null;
      this.campo.cpf = responseMe.nr_docto
        ? responseMe.nr_docto.toString().padStart(11, "0")
        : null;
      this.campo.DT_NASC = this.dados.DT_NASC ? this.dados.DT_NASC.slice(0, 10) : null;
      this.campo.selectCnh = this.optionTipoCnh.find((el) => {
        if (this.dados.IdTipoCnh) return el.Id == this.dados.IdTipoCnh || el.id == this.dados.IdTipoCnh;
        return el.TP_CNH == this.dados.TP_CNH;
      });
      this.campo.selectSexo = this.optionSexo.find((el) => {
        if (this.dados.IdSexo) return el.Id == this.dados.IdSexo || el.id == this.dados.IdSexo;
        return el.TP_SEXO == this.dados.TP_SEXO;
      });
      this.campo.selectOrientacaoSexual = this.optionOrientacao.find((el) => {
        if (this.dados.IdOrientacaoSexual) return el.Id == this.dados.IdOrientacaoSexual || el.id == this.dados.IdOrientacaoSexual;
        return el.tp_orientacao == this.dados.TP_ORIENTACAO_SEXO;
      });
      this.campo.selectEstadoCivil = this.optionEstadoCivil.find((el) => {
        if (this.dados.IdEstadoCivil) return el.Id == this.dados.IdEstadoCivil || el.id == this.dados.IdEstadoCivil;
        return el.TP_EST_CIVIL == this.dados.TP_EST_CIVIL;
      });
      this.campo.selectCaracteristasFisicas = this.optionCaracFisica.find((el) => {
        if (this.dados.IdRacaCor) return el.Id == this.dados.IdRacaCor || el.id == this.dados.IdRacaCor || el.sq_raca_cor == this.dados.IdRacaCor;
        if (!this.dados.SQ_RACA_COR) return false;
        if (el.sq_raca_cor == this.dados.SQ_RACA_COR || el.id == this.dados.SQ_RACA_COR) return true;
        
        const searchStr = typeof this.dados.SQ_RACA_COR === 'string' ? this.dados.SQ_RACA_COR.toLowerCase() : "";
        if (searchStr && el.nm_raca_cor) {
          return el.nm_raca_cor.toLowerCase() === searchStr;
        }
        return false;
      });

      const profissionalPrincipal = responseProfissional && Array.isArray(responseProfissional)
        ? responseProfissional.find((itm) => itm.PRINCIPAL === "Sim" || itm.principal === true)
        : null;
        
      if (profissionalPrincipal) {
        this.campo.registroProfissional = profissionalPrincipal;
        this.campo.selectRegistroProfissional = this.optionRegistroProfissional.find(
          (itm) => itm.tp_registro === (profissionalPrincipal.TPREGISTRO || profissionalPrincipal.tipoRegistro)
        ) || null;
      } else {
        this.campo.registroProfissional = null;
        this.campo.selectRegistroProfissional = null;
      }
      this.campo.nomeCompleto = responseMe.nm_razao;
      this.campo.nomeVerifica = responseMe.nm_razao;
      this.campoBK = Object.assign({}, this.campo);
      this.loading = false;
    },
    validarDadosPessoais() {
      if (
        !this.campo.nomeCompleto ||
        !this.campo.DT_NASC ||
        !this.campo.NR_PIS ||
        !this.campo.selectEstadoCivil ||
        !this.campo.selectSexo ||
        !this.campo.selectOrientacaoSexual ||
        !this.campo.selectCaracteristasFisicas
      ) {
        this.$tools.alerta(
          "Por favor, para continuar preencha todos os campos",
          "warning"
        );
        return false;
      }
      if (!this.pisValidado) {
        this.$tools.alerta("Verifique se o Nº do PIS está válido", "warning");
        return false;
      }
      return true;
    },
    async salvarDadosPessoais(valida = false) {
      if (valida) {
        if (!this.validarDadosPessoais()) {
          return;
        }
      }
      
      if (
        this.deficiencias.length > 0 &&
        this.campo.possuiDeficiencia.value == false
      ) {
        try {
          await this.$tools.alertaConfirm(
            "Esta ação irá excluir todas as deficiências cadastradas. Deseja continuar?"
          );
          await this.deletarPCDs();
        } catch {
          return false;
        }
      }
      
      let erpEstadoCivilVal = "";
      let erpIdEstadoCivilVal = null;
      if (this.campo.selectEstadoCivil) {
        erpEstadoCivilVal = this.campo.selectEstadoCivil.Descricao || this.campo.selectEstadoCivil.name || "";
        erpIdEstadoCivilVal = parseInt(this.campo.selectEstadoCivil.Id || this.campo.selectEstadoCivil.id || 0) || null;
      }

      let erpOrientacaoVal = "";
      let erpIdOrientacaoVal = null;
      if (this.campo.selectOrientacaoSexual) {
        erpOrientacaoVal = this.campo.selectOrientacaoSexual.Descricao || this.campo.selectOrientacaoSexual.name || "";
        erpIdOrientacaoVal = parseInt(this.campo.selectOrientacaoSexual.Id || this.campo.selectOrientacaoSexual.id || 0) || null;
      }

      let erpRacaCorVal = "";
      let erpIdRacaCorVal = null;
      if (this.campo.selectCaracteristasFisicas) {
        erpRacaCorVal = this.campo.selectCaracteristasFisicas.Descricao || this.campo.selectCaracteristasFisicas.nm_raca_cor || "";
        erpIdRacaCorVal = parseInt(this.campo.selectCaracteristasFisicas.Id || this.campo.selectCaracteristasFisicas.id || this.campo.selectCaracteristasFisicas.sq_raca_cor || 0) || null;
      }
      
      let erpIdSexoVal = null;
      if (this.campo.selectSexo) {
        erpIdSexoVal = parseInt(this.campo.selectSexo.Id || this.campo.selectSexo.id || (this.campo.selectSexo.TP_SEXO === 'M' ? 1 : 2));
      }
      
      let erpCnhVal = "";
      let erpIdCnhVal = null;
      if (this.campo.selectCnh) {
        erpCnhVal = this.campo.selectCnh.Descricao || this.campo.selectCnh.TipoCnh || this.campo.selectCnh.name || "";
        erpIdCnhVal = parseInt(this.campo.selectCnh.Id || this.campo.selectCnh.id || 0) || null;
      }

      const item = {
        Nome: this.campo.nomeCompleto,
        NomeCompleto: this.campo.nomeCompleto,
        nome: this.campo.nomeCompleto,
        
        DataNascimento: this.campo.DT_NASC,
        dataNascimento: this.campo.DT_NASC,
        dtNasc: this.campo.DT_NASC,

        Cpf: this.campo.cpf ? this.campo.cpf.replace(/[^\d]+/g, "") : "",
        cpf: this.campo.cpf ? this.campo.cpf.replace(/[^\d]+/g, "") : "",
        
        IdSexo: erpIdSexoVal,
        Sexo: this.campo.selectSexo ? (this.campo.selectSexo.TP_SEXO || "M") : "M",
        sexo: this.campo.selectSexo ? (this.campo.selectSexo.TP_SEXO || "M") : "M",
        tpSexo: this.campo.selectSexo ? (this.campo.selectSexo.TP_SEXO || "M") : "M",
        
        IdEstadoCivil: erpIdEstadoCivilVal,
        EstadoCivil: erpIdEstadoCivilVal ? { Id: erpIdEstadoCivilVal, Descricao: erpEstadoCivilVal } : null,
        estadoCivil: erpIdEstadoCivilVal ? { Id: erpIdEstadoCivilVal, Descricao: erpEstadoCivilVal } : null,
        tpEstadoCivil: this.campo.selectEstadoCivil ? (this.campo.selectEstadoCivil.TP_EST_CIVIL || "T") : "T",
        
        IdOrientacaoSexual: erpIdOrientacaoVal,
        OrientacaoSexual: erpIdOrientacaoVal ? { Id: erpIdOrientacaoVal, Descricao: erpOrientacaoVal } : null,
        orientacaoSexual: erpIdOrientacaoVal ? { Id: erpIdOrientacaoVal, Descricao: erpOrientacaoVal } : null,
        tpOrientacaoSexo: this.campo.selectOrientacaoSexual ? (this.campo.selectOrientacaoSexual.tp_orientacao || "E") : "E",
        
        IdRacaCor: erpIdRacaCorVal,
        RacaCor: erpIdRacaCorVal ? { Id: erpIdRacaCorVal, Descricao: erpRacaCorVal } : null,
        racaCor: erpIdRacaCorVal ? { Id: erpIdRacaCorVal, Descricao: erpRacaCorVal } : null,
        sqRacaCor: erpIdRacaCorVal,
        
        IdTipoCnh: erpIdCnhVal,
        Cnh: erpIdCnhVal ? { Id: erpIdCnhVal, TipoCnh: erpCnhVal } : null,
        cnh: erpIdCnhVal ? { Id: erpIdCnhVal, TipoCnh: erpCnhVal } : null,
        tpCnh: this.campo.selectCnh ? (this.campo.selectCnh.TP_CNH || "N") : "N",

        Pis: (this.campo.NR_PIS || "").replace(/[^\d]+/g, ""),
        pis: (this.campo.NR_PIS || "").replace(/[^\d]+/g, ""),
        PisNumero: (this.campo.NR_PIS || "").replace(/[^\d]+/g, ""),
        pisNumero: (this.campo.NR_PIS || "").replace(/[^\d]+/g, ""),
        NR_PIS: (this.campo.NR_PIS || "").replace(/[^\d]+/g, ""),
        NrPis: (this.campo.NR_PIS || "").replace(/[^\d]+/g, ""),
        nrPis: (this.campo.NR_PIS || "").replace(/[^\d]+/g, ""),

        CnhTipo: this.campo.selectCnh ? (this.campo.selectCnh.TP_CNH || "N") : "N",
        cnhTipo: this.campo.selectCnh ? (this.campo.selectCnh.TP_CNH || "N") : "N",
        TP_CNH: this.campo.selectCnh ? (this.campo.selectCnh.TP_CNH || "N") : "N"
      };

      this.loadingSalvar = true;
      
      const promises = [
        this.$http.put("api/profileErp/dados-pessoais", item)
      ];
      
      if (this.campo.selectRegistroProfissional && this.campo.selectRegistroProfissional.tp_registro) {
        // RegistroProfissional not sent right now as portal_api has no POST endpoint for it
      }

      await Promise.all(promises)
        .then(() => {
          Swal.fire({
            title: "<strong>Dados cadastrados com sucesso</strong>",
            icon: "success",
            timer: 5000,
            showCloseButton: true,
            showCancelButton: false,
            showConfirmButton: true,
            focusConfirm: false,
            position: "top-end",
          });
          this.$emit("carregarNivelPerfil");
          this.campoBK = Object.assign({}, this.campo);
        })
        .catch(() => {
          this.$tools.alerta("Erro ao cadastrar os dados pessoais no ERP", "error");
        });
      this.loadingSalvar = false;
    },
    validarPiss(pis) {
      pis = pis.replace(/\D/g, "");
      if (pis.length !== 11) {
        this.pisValidado = false;
        return;
      }
      if (/^(\d)\1+$/.test(pis)) {
        this.pisValidado = false;
        return;
      }
      var total = 0;
      var peso = [3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
      var resto;
      var dv = pis.substring(10, 11);
      for (var i = 0; i < 10; i++) {
        total += pis.charAt(i) * peso[i];
      }
      resto = 11 - (total % 11);
      if (resto === 10 || resto === 11) {
        resto = 0;
      }
      if (resto !== parseInt(dv)) {
        this.pisValidado = false;
        return;
      }
      this.pisValidado = true;
      return;
    },
    disabledData() {
      const dataAtual = new Date();
      dataAtual.setFullYear(dataAtual.getFullYear() - 18);
      return (date) => date >= dataAtual;
    },
    verificarNome(nome) {
      this.campo.nomeCompleto = nome.toUpperCase();
      if (/^(?=.*\s)[\p{L}\s]{0,60}$/u.test(nome)) {
        this.validacaoNome = true;
        return;
      } else {
        this.validacaoNome = false;
        return;
      }
    },
    // Métodos para controle do modal do PIS/INSS
    abrirModalPis() {
      this.showModalPis = true;
    },
    fecharModalPis() {
      this.showModalPis = false;
    },

    async fetchUserProfile() {
      // Para usuários ERP, não fazemos a requisição legada que gera erro 401
      this.disableProfissional = false;
    }
  },
};
</script>
